import { notification } from "antd";
import { InfoCircleOutlined, CloseCircleOutlined, CheckCircleOutlined } from "@ant-design/icons";

const info = (msg: string, duration: number = 4) => {
  notification.info({
    message: msg,
    placement: "bottom",
    className: "g-toast-info",
    duration,
    icon: <InfoCircleOutlined />,
  });
};

const warning = (msg: string, duration: number = 4) => {
  notification.warning({
    message: msg,
    placement: "bottom",
    className: "f-toast-warning",
    duration,
    icon: <InfoCircleOutlined />,
  });
};

const error = (msg: string, duration: number = 4) => {
  notification.error({
    message: msg,
    placement: "bottom",
    className: "f-toast-error",
    icon: <CloseCircleOutlined />,
    duration,
  });
};

const success = (msg: string, duration: number = 4) => {
  notification.success({
    message: msg,
    placement: "bottom",
    className: "f-toast-success",
    icon: <CheckCircleOutlined />,
    duration,
  });
};

export const toast = { info, error, success, warning };